import * as utils from '../js/utils';
import * as api from '../js/api';


interface PWindow extends Window {
    pay: {
        api: string
        stripe_publishable_key: string,
        checkout_redirect: boolean,
        checkout_url: string,
        checkout_button_text: string
    }
}
declare const window: PWindow;

class CartButton {
    private readonly form: HTMLFormElement;

    constructor(form: HTMLFormElement) {
        this.form = form;
    }

    private async showModal(name: string, args: {[key: string]: unknown}) {
        try {
            const {template} = await api.post(`/templates/${ name }`, args) as unknown as {template: string};
            const parent = document.createElement('div');
            parent.setAttribute('id', name);
            parent.innerHTML = template;
            parent.querySelectorAll('[data-action="modal-close"]').forEach((element) => {
                element.addEventListener('click', () => {
                    parent.remove();
                });
            });

            document.body.prepend(parent);
        } catch (e) {
            utils.showMessage({form: this.form, message: utils.getErrorMessage(e)});
        }
    }

    public async submit(event: Event) {
        const form = event.target;
        event.preventDefault();
        utils.setLoading({form: this.form, isLoading: true});

        // If the form has a data-checkout-url attribute, the item is already
        // in the cart.  Just redirect to the checkout URL on submit.
        if (this.form.dataset.checkoutUrl) {
            setTimeout( () => {
                utils.setLoading({form: event.target, isLoading: false});
            }, 5000);
            window.location.href = this.form.dataset.checkoutUrl;
            return;
        }

        try {
            const data = utils.formData({form});
            data.quantity = ( data.quantity !== undefined ) ? data.quantity : 1;
            await api.post('/cart/items', data);

            if (window.pay.checkout_redirect) {
                setTimeout( () => {
                    utils.setLoading({form: event.target, isLoading: false});
                }, 5000);
                window.location.href = window.pay.checkout_url;
                return;
            }
            this.form.dataset.checkoutUrl = window.pay.checkout_url;

            await this.showModal('product-modal', data);
            utils.setButtonText({form, text: window.pay.checkout_button_text});
        } catch (e) {
            utils.showMessage({form, message: utils.getErrorMessage(e)});
        }
        utils.setLoading({form: event.target, isLoading: false});
    }
}

export default async function() {
    document.querySelectorAll('.payments-product-form,.payments-subscription-form').forEach((element) => {
        const cart = new CartButton( element as HTMLFormElement );
        element.addEventListener('submit', cart.submit.bind(cart));
    });
}